import {
  ToothAIcon, ToothBIcon, ToothCIcon, ToothDIcon,
  ToothEIcon, ToothFIcon, ToothGIcon, ToothHIcon,
  ToothIIcon, ToothJIcon, ToothKIcon, ToothLIcon,
  ToothMIcon, ToothNIcon, ToothOIcon, ToothPIcon,
  ToothQIcon, ToothRIcon, ToothSIcon, ToothTIcon,
} from '@shared/icons';

export const upperPrimary = [
  {
    value: 'Tooth #55',
    icon: <ToothAIcon />,
    label: '55',
  },
  {
    value: 'Tooth #54',
    icon: <ToothBIcon />,
    label: '54',
  },
  {
    value: 'Tooth #53',
    icon: <ToothCIcon />,
    label: '53',
  },
  {
    value: 'Tooth #52',
    icon: <ToothDIcon />,
    label: '52',
  },
  {
    value: 'Tooth #51',
    icon: <ToothEIcon />,
    label: '51',
  },
  {
    value: 'Tooth #61',
    icon: <ToothFIcon />,
    label: '61',
  },
  {
    value: 'Tooth #62',
    icon: <ToothGIcon />,
    label: '62',
  },
  {
    value: 'Tooth #63',
    icon: <ToothHIcon />,
    label: '63',
  },
  {
    value: 'Tooth #64',
    icon: <ToothIIcon />,
    label: '64',
  },
  {
    value: 'Tooth #65',
    icon: <ToothJIcon />,
    label: '65',
  },
];

export const lowerPrimary = [
  {
    value: 'Tooth #85',
    icon: <ToothTIcon />,
    label: '85',
  },
  {
    value: 'Tooth #84',
    icon: <ToothSIcon />,
    label: '84',
  },
  {
    value: 'Tooth #83',
    icon: <ToothRIcon />,
    label: '83',
  },
  {
    value: 'Tooth #82',
    icon: <ToothQIcon />,
    label: '82',
  },
  {
    value: 'Tooth #81',
    icon: <ToothPIcon />,
    label: '81',
  },
  {
    value: 'Tooth #71',
    icon: <ToothOIcon />,
    label: '71',
  },
  {
    value: 'Tooth #72',
    icon: <ToothNIcon />,
    label: '72',
  },
  {
    value: 'Tooth #73',
    icon: <ToothMIcon />,
    label: '73',
  },
  {
    value: 'Tooth #74',
    icon: <ToothLIcon />,
    label: '74',
  },
  {
    value: 'Tooth #75',
    icon: <ToothKIcon />,
    label: '75',
  },
];
